var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap-nav"},[_c('Nav'),_c('div',{staticClass:"wrap-content"},[(_vm.navAwards[1].active)?_c('Rules'):_vm._e(),(_vm.navAwards[0].active)?_c('Judges'):_vm._e(),(_vm.navAwards[2].active)?_c('Categories'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }